module.exports = __webpack_public_path__ + "img/tom-collins.550fd16e.jpg";